import { inject } from 'aurelia-framework';
import { NewInstance } from 'aurelia-dependency-injection';
import { UserService } from '../Advertiser.SharedPortal/services/user-service';
import { User } from '../models/user';
import { ValidationController, validateTrigger, ValidationRules, ValidateBindingBehavior, ValidationRenderer } from 'aurelia-validation';
import { Router } from 'aurelia-router';
import { LoggerService } from '../Advertiser.SharedPortal/services/logger-service';
import { StatusService } from '../Advertiser.SharedPortal/services/status-service';
import { MultiObserverService } from '../Advertiser.SharedPortal/services/multi-observer-service';
import { BrowserStorageService } from '../Advertiser.SharedPortal/services/browser-storage-service';


var config = require('../../config.js');

@inject(Router, UserService, NewInstance.of(ValidationController), LoggerService, StatusService, MultiObserverService, BrowserStorageService)
export class Login {
   constructor(router, userService, controller, logger, status, multiObserver, browserStorage) {
      this.router = router;
      this.userService = userService;
      this.controller = controller;
      this.logger = logger;
      this.status = status;
      this.multiObserver = multiObserver;
      this.browserStorage = browserStorage;

      this.user = new User();
      this.errorMessage = '';
      this.heading = 'Log in';
      this.controller.validateTrigger = validateTrigger.manual;
      this.forgotPasswordUrl = '#/forgot-password';
      this.myKeypressCallback = this.keypressInput.bind(this);
      this.showTestGlobalExceptionHandler = this.browserStorage.getItem('testglobalerrorhandler') === 'true';
   }

   activate(params, routeConfig) {
      let that = this;
      this.configStatus();
      this.user.emailAddress = params.emailaddress;
      this.multiObserver.observe(this.user, ['emailAddress', 'password'], function () { that.status.dirty(); });
      window.addEventListener('keypress', this.myKeypressCallback, false);
   }

   deactivate() {
      window.removeEventListener('keypress', this.myKeypressCallback);
   }

   keypressInput(e) {
      if (e.key === 'Enter') {
         this.onSubmit();
      }
   }

   configStatus() {
      // statuses:  dontchange, clean, dirty, working, loading, saving, success, error
      this.status.texts = ['', 'Log In', 'Log In', 'Logging In', '', '', 'Logged In', 'Error'];
      this.status.classes = ['', 'btn-disabled', 'btn-enabled', 'btn-processing', '', '', 'btn-success', 'btn-error'];
      this.status.clean();
   }

   /* login response looks like this:
   Response: 
   AccessToken: "eyJraWQiOiJM......."
   cookies: {
      auth: "Authorization=AQECAHhKdUs......;path=/;domain=dev-www.delty.io;secure;httpOnly"
      keypair: "CloudFront-Key-Pair-Id=APKAI4VS26SQQHQY7S3A..............;path=/;domain=dev-www.delty.io;secure;httpOnly"
      policy: "CloudFront-Signature=k6ECEh5B1aJ-DVX;path=/;domain=dev-www.delty.io;secure;httpOnly"
   }
   */
   onSubmit() {
      this.logger.debug('onSubmit() called');
      let that = this;
      let errorMessage = '';
      this.errors = [];

      let errors = this.controller.validate()
         .then((results) => {
            if (results.valid) {
               that.status.working();
               that.errorMessage = '';
               that.controller.reset();

               that.userService.login( that.user )
                  .then(response => {
                     that.logger.debug( 'login returns:', response );
                     
                     if (response && response[0] === 'Success') {
                        that.errorMessage = '';
                        that.status.set(that.status.statuses.success, that.status.success.clean, config.buttonReset);
                        setTimeout(function () { that.userService.redirectToPortal(); }, 1500);
                     } else {
                        that.errorMessage = "Sorry, the username or password you entered is incorrect. Please re-enter.";
                        that.status.dirty();
                        that.status.set(that.status.statuses.error, that.status.success.clean, config.buttonReset);
                     }
                  });
            } else {
                console.log('Validation error on username & email called...', results);
            }
         });
   }



   newUser() {
      this.user = new User();
      this.errorMessage = '';
   }
}

var passwordRegex = /(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[\^\$\*\.\[\]\{\}\(\)\?\-\"\!\@\#\%\&\/\,><':;|_~`]).{8,}/;

ValidationRules
   .ensure(p => p.emailAddress).required()
   .ensure(p => p.emailAddress).email().withMessage('Email address is improperly formated (please ensure it is all lowercase)')
   .ensure(p => p.password).required()
   .ensure(p => p.password).matches(passwordRegex).withMessage('Sorry, the username or password you entered is incorrect. Please re-enter.')
   .on(User);
